import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CompanyContractsComponent } from './company-contracts.component';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        CompanyContractsComponent
    ], imports: [CoreModule,
        CommonModule,
        FormsModule,
        DropdownModule,
        MultiSelectModule,
        ButtonModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CompanyContractsModule { }
